import React from "react";
import ManagePlans from "../../Admin/manage-plan/ManagePlans";

const ManagePlanScreen = () => {
    return <ManagePlans />;
};

export default ManagePlanScreen;
